import { UserAddOutlined } from '@ant-design/icons';
import { type NodeProps } from '@xyflow/react';
import UpdateLeadActionNodeContent from 'automations/components/Nodes/UpdateLeadActionNodeContent';
import { type UpdateLeadNodeType } from 'automations/types/nodeSchemas/actionNodes';
import { nodeSchemas } from 'automations/types/nodeTypes';
import { getErrorList } from 'automations/utils/zod';
import { useMemo } from 'react';

import { type ActionNodeReturnProps } from './useActionNodeConfig';

export default function useUpdateLead(node: NodeProps<UpdateLeadNodeType>): ActionNodeReturnProps {
  const errorMessages = useMemo(() => getErrorList(nodeSchemas.UpdateLeadActionNodeData, node.data), [node.data]);
  const AdditionalUI = useMemo(() => <UpdateLeadActionNodeContent node={node} />, [node]);

  const subTitle = useMemo(() => {
    const updateData = node.data?.additionalOptions?.updateLead;

    return updateData?.map((val) => `Set ${val.schemaName} to ${val.value}`).join(', ');
  }, [node.data?.additionalOptions?.updateLead]);

  return {
    subTitle,
    icon: UserAddOutlined,
    hasErrors: errorMessages.length > 0,
    errorMessages,
    AdditionalUI,
  };
}
